<template>
  <v-menu>
    <template #activator="{ on }">
      <v-btn
        small
        depressed
        :color="statusColor"
        :loading="isLoading"
        class="ma-0"
        v-on="createActivatorListeners(on)"
      >
        {{ statusText }}
        <v-icon right>arrow_drop_down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-tile
        v-for="option in options"
        :key="option.value"
        @click="handleOptionClick(option.value)"
      >
        <v-list-tile-title>{{ option.text }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    options() {
      return [
        { value: 'pending', text: this.$t('pending2'), color: 'default' },
        { value: 'in_progress', text: this.$t('in_progress'), color: 'warning' },
        { value: 'completed', text: this.$t('completed'), color: 'success' }
      ]
    },
    statusText() {
      return (this.options.find(({ value }) => value === this.value) || {}).text || ''
    },
    statusColor() {
      return (this.options.find(({ value }) => value === this.value) || {}).color
    }
  },
  methods: {
    createActivatorListeners({ click, ...rest }) {
      return {
        ...rest,
        click: (event) => {
          event.stopPropagation()
          click(event)
        }
      }
    },
    handleOptionClick(value) {
      this.$emit('change', value, () => {
        this.isLoading = !this.isLoading
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/issueReport/StatusSelect.vue